import { ContactForm } from "@holigral/shared/contact"
import { H1 } from "@holigral/shared/ui/components"
import { Card, CardContent } from "@holigral/shared/ui/components/ui/card"
import { useSubmitContactMutation } from "./api"
import { Trans, useT } from "@/i18n"

const SUPPORT_EMAIL = "hello@profiling.app"

export default function Contact() {
  const { t } = useT("content")
  const [submitContact] = useSubmitContactMutation()

  return (
    <div className="mx-auto max-w-lg px-6 py-12">
      <H1>{t("getInTouch")}</H1>

      <p className="mb-4 text-muted-foreground">
        <Trans
          t={t}
          i18nKey="contactIntro"
          values={{ email: SUPPORT_EMAIL }}
          components={{
            supportLink: (
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                className="text-foreground hover:underline"
              />
            ),
          }}
        />
      </p>

      <Card>
        <CardContent>
          <ContactForm action={submitContact} />
        </CardContent>
      </Card>
    </div>
  )
}
